import { colors } from "global/react-mui/theme/colors";
import { IPartner } from "../../../model/partner";
import { mapStyles } from "./mapStyles";
import { GoogleLatLng, GoogleMap, GoogleMarker, GoogleReadonlySymbol } from "./types";
const mapMarker = require('./../marker.svg') as any;
interface MapUtils {
	/**
	 * Get an SVG map marker icon, with customisable colour
	 * @param iconColor The icon color
	 * @returns GoogleReadonlySymbol
	 */
	createMap: ({ mapRef: HTMLDivElement, mapType: string, centerAddress: GoogleLatLng, zoomLevel: number }) => GoogleMap;
	/**
	 * Get an SVG map marker icon, with customisable colour
	 * @param iconColor The icon color
	 * @returns GoogleReadonlySymbol
	 */
	getMapIconSymbol: (settings: Partial<GoogleReadonlySymbol>) => GoogleReadonlySymbol;
	/**
	 * Geocode an address or point on the map at specific coords
	 * @param location GoogleLatLng
	 * @param map the map
	 * @param data data to add on the marker
	 * @returns GoogleMarker
	 */
	addMapMarker: (location: GoogleLatLng, map: GoogleMap, partner: IPartner, infoWindow: google.maps.InfoWindow) => GoogleMarker;
	/**
	 * Remove Google Markers
	 * @param markers GoogleMarker[]
	 */
	removeMapMarkers: (markers: GoogleMarker[]) => void
	/**
	 * Add a marker for home and its listener
	 * @param location GoogleLatLng
	 * @param map the map
	 * @param data data to add on the marker
	 * @returns GoogleMarker
	 */
	addHomeMarker: (location: GoogleLatLng, map: GoogleMap) => GoogleMarker;
	/**
	 * Geocode an address or point on the map at specific coords
	 * @param coordinate
	 * @param onGeocodeSuccessCallback setMarker callback
	 */
	coordinateToAddress: (coordinate: GoogleLatLng, onGeocodeSuccessCallback: (any: any) => Promise<void>) => void
}

export const MapUtils: MapUtils = {
	createMap: ({ mapRef, mapType, centerAddress, zoomLevel }) => new google.maps.Map(mapRef.current, {
		mapTypeId: mapType,
		mapTypeControlOptions: {
			mapTypeIds: ['styled_map'],
		},
		center: centerAddress,
		zoom: zoomLevel,
		streetViewControl: false,
		rotateControl: false,
		scaleControl: true,
		fullscreenControl: false,
		panControl: false,
		zoomControl: true,
		zoomControlOptions: {
			position: google.maps.ControlPosition.RIGHT_TOP,
		},
		gestureHandling: 'cooperative',
		draggableCursor: 'pointer',
		mapTypeControl: false,
		styles: mapStyles,
	}),
	getMapIconSymbol: (settings) => {
		const symbolBase: GoogleReadonlySymbol = {
			path: 'M16,0C9.9,0,4.9,4.6,4.9,10.3C4.9,18.3,16,32,16,32s11.1-13.7,11.1-21.7C27.1,4.6,22.1,0,16,0z M16,14.7c-2,0-3.6-1.6-3.6-3.6S14,7.5,16,7.5c2,0,3.6,1.6,3.6,3.6l0,0l0,0C19.6,13.1,18,14.7,16,14.7C16,14.7,16,14.7,16,14.7z',
			fillColor: '#000000',
			fillOpacity: 0.8,
			strokeColor: 'white',
			strokeWeight: 2,
			anchor: new google.maps.Point(30, 50),
		};

		// overwrite symbol settings
		const newSymbol = Object.assign(symbolBase, settings);
		return {
			...newSymbol,
		};
	},
	addMapMarker: (location, map, partner, infoWindow): GoogleMarker => {
		const newMarker: { partnerId?: string } & GoogleMarker = new google.maps.Marker({
			position: location,
			map: map,
			icon: MapUtils.getMapIconSymbol({
				fillColor: colors["wolf-red"],
				scale: 1.3,
				path: 'M16,0C9.9,0,4.9,4.6,4.9,10.3C4.9,18.3,16,32,16,32s11.1-13.7,11.1-21.7C27.1,4.6,22.1,0,16,0z M16,14.7c-2,0-3.6-1.6-3.6-3.6S14,7.5,16,7.5c2,0,3.6,1.6,3.6,3.6l0,0l0,0C19.6,13.1,18,14.7,16,14.7C16,14.7,16,14.7,16,14.7z',
			}),
		})

		const infoWindowContent = `<div style="font-size: 16px">
			<span><b>${partner.name}</b></span></br>
			<span>${partner.address.address1} ${partner.address.address2}</span></br>
			<span>${partner.address.city} ${partner.address.postcode}</span>
			</div>`

		// https://developers.google.com/maps/documentation/javascript/examples/infowindow-simple
		// newMarker.addListener("click", () => {
		// 	infowindow.open(map, newMarker);
		// });

		google.maps.event.addListener(newMarker, 'mouseover', function () {
			infoWindow.setOptions({
				content: infoWindowContent,
				maxWidth: 300
			});
			infoWindow.open(map, newMarker);
		});


		newMarker.partnerId = partner.id as string

		return newMarker
	},
	removeMapMarkers: (markers) => {
		for (let i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}
	},
	addHomeMarker: (location, map) => {
		const homeMarkerConst: GoogleMarker = new google.maps.Marker({
			position: location,
			map: map,
			icon: {
				url: mapMarker,
				scaledSize: new google.maps.Size(30, 40, 'px'), // https://stackoverflow.com/questions/23264872/resize-svg-icon-for-google-map-marker
			},
		});

		homeMarkerConst.addListener('click', () => {
			map?.panTo(location);
			map?.setZoom(15);
		});

		return homeMarkerConst;
	},
	coordinateToAddress: async (coordinate, onGeocodeSuccessCallback) => {
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode({ location: coordinate }, function (results, status) {
			if (status === 'OK') {
				onGeocodeSuccessCallback({
					label: results[0].formatted_address,
					lat: coordinate.lat(),
					lng: coordinate.lng(),
				});
			}
		});
	}
}
